module.exports = __webpack_public_path__ + "img/instagram.3b83c3d6.png";